// extracted by mini-css-extract-plugin
export default {"menuButton":"SidebarMenu_menuButton__OqF-+"};